var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNewPassenger = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.75V6.25C9.5 6.38807 9.38807 6.5 9.25 6.5H6.5V9.25C6.5 9.38807 6.38807 9.5 6.25 9.5H5.75C5.61193 9.5 5.5 9.38807 5.5 9.25V6.5H2.75C2.61193 6.5 2.5 6.38807 2.5 6.25V5.75C2.5 5.61193 2.61193 5.5 2.75 5.5H5.5V2.75C5.5 2.61193 5.61193 2.5 5.75 2.5H6.25C6.38807 2.5 6.5 2.61193 6.5 2.75V5.5H9.25C9.38807 5.5 9.5 5.61193 9.5 5.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0031 12C17.7931 12 16.0015 13.7909 16.0015 16C16.0015 17.0609 16.4231 18.0783 17.1736 18.8284C17.924 19.5786 18.9418 20 20.0031 20C22.213 20 24.0046 18.2091 24.0046 16C24.0046 13.7909 22.213 12 20.0031 12ZM26.4555 23.66L27.896 26.55C28.0521 26.8595 28.0366 27.2277 27.8553 27.5231C27.6739 27.8185 27.3524 27.999 27.0057 28H13.0004C12.6537 27.999 12.3322 27.8185 12.1508 27.5231C11.9695 27.2277 11.954 26.8595 12.1101 26.55L13.5506 23.66C14.0596 22.6408 15.1021 21.9978 16.2416 22H23.7645C24.904 21.9978 25.9465 22.6408 26.4555 23.66Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewPassenger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NewPassenger.fab0eb03.svg";
export { ForwardRef as ReactComponent };